import EmptyState from './EmptyState.json';
import RawValues from './RawValues.json';
import ValueFormatting from './ValueFormatting.json';
import CustomValueFormatting from './CustomValueFormatting.json';
import CustomColumnAlignment from './CustomColumnAlignment.json';
import CellType from './CellType.json';

export default [EmptyState, RawValues, ValueFormatting, CustomValueFormatting, CustomColumnAlignment, CellType];
